// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsvideoconfig = {
    "awsInputVideo": "geovisualvideos-dov-input-jpklrc5xffs2",
    "awsOutputVideo": "geovisualvideos-dov-output-jpklrc5xffs2.s3.us-east-1.amazonaws.com"
};

export default awsvideoconfig;